import { ReactNode } from "react";
import { IImageProps } from "apps/website/components/base/Image/Image";

export interface INibblesPouchesUpsellItem {
  id: string;
  content: ReactNode;
}

export const NIBBLES_POUCHES_UPSELL_MODAL_TITLE = "Get 50% off treats";
export const NIBBLES_POUCHES_UPSELL_MODAL_SUBHEADING = "NIBBLES TRIO BUNDLE - 100% MEAT + FISH";
export const NIBBLES_POUCHES_UPSELL_MODAL_DESCRIPTION = "A bundle of our irresistible freeze-dried 100% meat and fish treats. No sugar, no nasties, no fuss.";

export const NIBBLES_POUCHES_UPSELL_MODAL_IMAGE: IImageProps = {
  src: "/images/nibbles-trio-over-table.webp",
  width: 4991,
  height: 2870,
};

export const NIBBLES_POUCHES_UPSELL_MODAL_ITEMS: INibblesPouchesUpsellItem[] = [
  { id: "salmon", content: <>1 x 15g <strong className="font-bold">salmon</strong> fillet Nibbles</> },
  { id: "tuna", content: <>1 x 15g <strong className="font-bold">tuna</strong> fillet Nibbles</> },
  { id: "chicken", content: <>1 x 15g <strong className="font-bold">chicken</strong> breast Nibbles</> },
];

export const NIBBLES_POUCHES_UPSELL_MODAL_PRICE_BEFORE_DISCOUNT = 5.97;
export const NIBBLES_POUCHES_UPSELL_MODAL_PRICE_AFTER_DISCOUNT = 2.99;

export const NIBBLES_POUCHES_UPSELL_MODAL_FOOTER_TEXT = "Add these to your ongoing plan. Change or remove at any time from your account.";
export const NIBBLES_POUCHES_UPSELL_MODAL_ADD_TO_ORDER_BUTTON_TEXT = "Add to box";
export const NIBBLES_POUCHES_UPSELL_MODAL_PICK_OWN_BUTTON_TEXT = "I want to pick my own";
export const NIBBLES_POUCHES_UPSELL_MODAL_SUCCESS_TEXT = "Added to your ongoing deliveries.";

export const NIBBLES_POUCHES_UPSELL_MODAL_SUCCESS_IMAGE: IImageProps = {
  src: "https://a.storyblok.com/f/176726/150x150/8f369a4b79/katkin_thescratchingpost_january_illus-1.svg",
  width: 500,
  height: 300,
};

export const NIBBLES_POUCHES_UPSELL_MODAL_CARD_TAG = "50% off";
